// extracted by mini-css-extract-plugin
module.exports = {"documentContainer":"ReceiptLogUnitDetail_documentContainer_WNuT4","document":"ReceiptLogUnitDetail_document_38KkH","images":"ReceiptLogUnitDetail_images_2mY-D"};